<template>
    <div>
        <el-tabs v-model="activeTab" type="border-card">
            <el-tab-pane :lazy="true" label="Услуги и скидки" name="discounts">
                <discounts />
            </el-tab-pane>
            <el-tab-pane :lazy="true" label="Модули скидок" name="modules">
                <modules />
            </el-tab-pane>
            <el-tab-pane :lazy="true" label="Группы клиентов" name="groups">
                <groups />
            </el-tab-pane>
            <el-tab-pane :lazy="true" label="Черный список" name="blacklist">
                <blacklist />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import discounts from './components/discounts'
    import modules from './components/modules'
    import groups from './components/groups'
    import blacklist from './components/blackList'

    export default {
        components: { discounts, modules, groups, blacklist },
        data () {
            return {
                activeTab: 'discounts'
            }
        }
    }
</script>

<style scoped>

</style>
